import StoreTempoOAuthCredentialsSaga from './StoreTempoOAuthCredentialsSaga'
import GetTempoOAuthConfigSaga from './GetTempoOAuthConfigSaga'

export default [GetTempoOAuthConfigSaga, StoreTempoOAuthCredentialsSaga]
